import React, { FunctionComponent } from 'react';
import Page from '@/components/layout/Page';
import Header from '@/components/typography/Header';
import DesignText from '@/components/typography/DesignText';
import PrismicRichText from '@/components/design/PrismicRichText';
import { IPrismicRichTextElement } from '@/pageGeneration/services/prismicApi/types';

interface IProps {
  title: string;
  subtitle: string;
  text: IPrismicRichTextElement[];
}

const StaticTextPage: FunctionComponent<IProps> = ({ title, subtitle, text }) => (
  <Page>
    <Header level={1} marginBottom={0} sizeLevel={2}>
      {title}
    </Header>
    <div style={{ marginBottom: 8 }}>
      <DesignText italic>{subtitle}</DesignText>
    </div>
    <PrismicRichText items={text} />
  </Page>
);

export default StaticTextPage;
